import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import { useTranslation } from 'react-i18next';
import { NavigationBar } from '../../Components/navigationbar/NavigationBar';
import { Footer } from '../../Components/Layout/footer/Footer';
import Layout from '../../Components/Layout';
import classes from './error_pages.module.scss';
import { Header } from '../../Components/Layout/components';

export function ErrorPage() {
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const location = useLocation();
  const [t] = useTranslation();

  const tamplate404 = (
    <div className={classes.container}>
      <div className={classes.outer}>
        <div className={classes.inner}>
          <p className={classes.statuscode}>{location.pathname === '/500' ? 500 : 404}</p>
          <p className={classes.mainmsg}>
            {location.pathname === '/500' ? t('common.general.internalerror') : t('common.general.notfound')}
          </p>
          <p className={classes.text}>
            {location.pathname === '/500' ? t('common.general.internalerrortext') : t('common.general.notfoundtext')}
          </p>
          <button onClick={() => navigate(-1)} className="btn btn-primary">
            {t('common.general.goback')}
          </button>
        </div>
      </div>
    </div>
  );

  if (isAuthenticated) {
    return <Layout showFooter={false}>{tamplate404}</Layout>;
  }

  return (
    <div className={classes.unAuthContainer}>
      <Header />
      {tamplate404}
      <Footer />
    </div>
  );
}
